var render = function render(_c,_vm){return _c('svg',{attrs:{"width":"13","height":"8","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M2 2l4.5 4.5L11 2","fill":"none","stroke-width":"2","stroke-linecap":"square","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }